var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteWarningImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112.726,
    height: 104.828,
    viewBox: "0 0 112.726 104.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66125",
    "data-name": "Group 66125",
    transform: "translate(-967.914 -576.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-module",
    transform: "translate(967.914 579.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9554",
    "data-name": "Path 9554",
    d: "M50.991,0A50.991,50.991,0,1,1,0,50.991,50.991,50.991,0,0,1,50.991,0Z",
    fill: "rgba(118,116,147,0.22)",
    opacity: 0.996
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66124",
    "data-name": "Group 66124",
    transform: "translate(962.068 573.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15405",
    "data-name": "Group 15405",
    transform: "translate(43.086 38.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M19.643,0a1.964,1.964,0,0,1,1.964,1.964h3.929a1.964,1.964,0,0,1,0,3.929H1.964a1.964,1.964,0,1,1,0-3.929H5.893A1.964,1.964,0,0,1,7.857,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M20,28H4a4.005,4.005,0,0,1-4-4V0H24V24A4.005,4.005,0,0,1,20,28ZM17,4a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V5A1,1,0,0,0,17,4ZM7,4A1,1,0,0,0,6,5V23a1,1,0,0,0,2,0V5A1,1,0,0,0,7,4Z",
    transform: "translate(2 8)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-info-circle",
    "data-name": "Icon awesome-info-circle",
    d: "M17.382.563A16.82,16.82,0,1,0,34.2,17.382,16.822,16.822,0,0,0,17.382.563Zm0,7.46a2.849,2.849,0,1,1-2.849,2.849A2.849,2.849,0,0,1,17.382,8.023Zm3.8,17.227a.814.814,0,0,1-.814.814H14.4a.814.814,0,0,1-.814-.814V23.622a.814.814,0,0,1,.814-.814h.814V18.467H14.4a.814.814,0,0,1-.814-.814V16.026a.814.814,0,0,1,.814-.814h4.341a.814.814,0,0,1,.814.814v6.782h.814a.814.814,0,0,1,.814.814Z",
    transform: "translate(1046.438 575.798)",
    fill: "#f7c76c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWarningImage);
export default __webpack_public_path__ + "static/media/delete_warning_image.fc22f9fe77fc616668d45aef0ade01f1.svg";
export { ForwardRef as ReactComponent };